document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('.article-template__content');
  if (!root) return;
  renderMathInElement(root, {
    delimiters: [
      {left: '$$', right: '$$', display: true},
      {left: '\\[', right: '\\]', display: true},
      {left: '\\(', right: '\\)', display: false},
      {left: '$', right: '$', display: false}
    ],
    ignoreClass: 'pp-ignore-math',   // add this to any block you want skipped
    throwOnError: false
  });
});
